var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-file__container"},[_c('iframe',{attrs:{"src":'https://docs.google.com/gview?url=' + _vm.link + '&embedded=true'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }